import { BookingSteps, ProcessTypes, UserWorkoutSession } from 'fitbeat.gym-core';
import { BaseUserProfile, GymTypes } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { connect, DispatchProp } from 'react-redux';
import { Button, ButtonSize, ButtonTypes } from '../../components';
import { GymResolver } from '../../services';
import Theme from '../../theme';
import { i18n } from '../../utils';
import { getNextBookingStep, getPreviousBookingStep, setSoloWorkout } from '../actions';
import {
  BookingFlowFooter, BookingInstructionHeader, BookingInstructionSubtitle, InviteFriendsSelection,
} from '../components';
import { styles as sharedStyles } from './Styles';

export interface IProps {
  userProfile: BaseUserProfile;
  workoutSession: UserWorkoutSession;
  workoutSessionService: any;
  isSoloWorkout: boolean | null;
  previousBookingSteps: BookingSteps[];
  currentSelectedGymName: string;
  fromPlanner: boolean;
  t(key: string): string;
  setSoloWorkout(isSoloWorkout: boolean): string;
  getNextBookingStep(processType: ProcessTypes, fromPlanner: boolean): any;
  getPreviousBookingStep(): any;
}

const InviteFriends: FunctionComponent<IProps> = ({
  t,
  workoutSession,
  isSoloWorkout,
  previousBookingSteps,
  getNextBookingStep,
  getPreviousBookingStep,
  setSoloWorkout,
  currentSelectedGymName,
  fromPlanner,
}) => {
  const hasPreviousStep = previousBookingSteps.length > 0;
  const gym = GymResolver.getByName(currentSelectedGymName);
  const isHomeGym = gym.type === GymTypes.Home;
  return (
    <View style={styles.container}>
      <View style={sharedStyles.body}>
        <BookingInstructionHeader header={
          isHomeGym ? t('inviteFriends') : t('inviteWorkoutPartner')} />
        <InviteFriendsSelection
          t={t}
          isSoloWorkout={isSoloWorkout}
          setSoloWorkout={setSoloWorkout}
        />
        <BookingInstructionSubtitle
          header={isHomeGym
            ? t('inviteFriendsToTrainWithYou')
            : t('workoutPartnerTrainWithYou')}
        />
      </View>
      <BookingFlowFooter style={styles.footer}>
        {hasPreviousStep &&
          <Button
            fontColor={Theme.PRIMARY}
            size={ButtonSize.MEDIUM}
            buttonType={ButtonTypes.OUTLINE}
            title={i18n.t('bookings:back')}
            onPress={() => getPreviousBookingStep()}
            containerStyle={styles.backContainer}
          />
        }

        <Button
          fontColor={Theme.WHITE}
          size={ButtonSize.MEDIUM}
          disabled={isSoloWorkout === null}
          title={i18n.t('bookings:next')}
          onPress={() => getNextBookingStep(
            workoutSession ? ProcessTypes.ChangeBooking : ProcessTypes.Start, fromPlanner)}
          containerStyle={[styles.nextContainer, { flex: hasPreviousStep ? 0.7 : 1 }]}
        />
      </BookingFlowFooter>
    </View>
  );
};

const mapStateToProps = (state): Partial<IProps> => {
  return {
    isSoloWorkout: state.bookings.bookingWizard.isSoloWorkout,
    previousBookingSteps: state.bookings.bookingWizard.previousBookingSteps,
    workoutSession: state.bookings.bookingWizard.workoutSession,
    currentSelectedGymName: state.bookings.bookingWizard.currentSelectedGymName,
    fromPlanner: state.bookings.bookingWizard.fromPlanner,
  };
};

const mapDispatchToProps = (dispatch, ownProps: IProps ) => {
  const { userProfile } = ownProps;
  return {
    getNextBookingStep: (processType, fromPlanner) =>
      dispatch(getNextBookingStep(userProfile, processType, undefined, undefined, fromPlanner)),
    getPreviousBookingStep: () => dispatch(getPreviousBookingStep()),
    setSoloWorkout: (isSoloWorkout: boolean) => dispatch(setSoloWorkout(isSoloWorkout, userProfile)),
  };
};

export const InviteFriendsStep = connect(mapStateToProps, mapDispatchToProps)(
  translate(['bookings', 'common'], { wait: true })(InviteFriends));

InviteFriendsStep.getTitle = () => <></>;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  footer: {
    flexDirection: 'row',
  },
  backContainer: {
    flex: 0.3,
  },
  nextContainer: {
    flex: 0.7,
    marginLeft: 5,
  },
});
